export default __webpack_public_path__ + "static/media/003.c87f00f0.md";